export const extractAttributeName = (attribute: string) => {
    return attribute.split("-").pop();
}